import type { FormikConfig } from 'formik';
import type { ModalData } from '..';

export interface MtSocialProvidersLinkEmailFormValues {
  email: string;
  password: string;
  confirmPassword: string;
}

export interface MtSocialProvidersLinkEmailModalData {
  modal: ModalData;
  form: FormikConfig<MtSocialProvidersLinkEmailFormValues>;
}

export interface MtSocialProvidersLinkEmailModalProps extends MtSocialProvidersLinkEmailModalData {}
